import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { appRoutes } from './routes';
import Login from '../features/auth/pages/Login';
import { hasValidStoredAccessToken } from '../api';
import { getPostLoginRedirect } from '../utils/authRedirect';

const protectedRoutes = appRoutes.filter((route) => route.props?.path !== '/login');

function RequireAuth({ children }) {
  const location = useLocation();
  if (!hasValidStoredAccessToken()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function LoginRoute() {
  const location = useLocation();
  if (hasValidStoredAccessToken()) {
    const redirectTo = getPostLoginRedirect(location.state?.from);
    return <Navigate to={redirectTo} replace />;
  }
  return <Login />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route
        path="*"
        element={(
          <RequireAuth>
            <Routes>{protectedRoutes}</Routes>
          </RequireAuth>
        )}
      />
    </Routes>
  );
}

export default App;
